// Liste des aliments pour la diversification alimentaire
// Organisée par catégories avec emojis

export const FOOD_CATEGORIES = {
  fruits: {
    label: 'Fruits',
    emoji: '🍎',
    color: 'red'
  },
  vegetables: {
    label: 'Légumes',
    emoji: '🥕',
    color: 'green'
  },
  starches: {
    label: 'Féculents',
    emoji: '🍞',
    color: 'amber'
  },
  proteins: {
    label: 'Protéines',
    emoji: '🍗',
    color: 'orange'
  },
  dairy: {
    label: 'Produits laitiers',
    emoji: '🧀',
    color: 'yellow'
  },
  other: {
    label: 'Autres',
    emoji: '🥄',
    color: 'gray'
  }
};

export const FOODS = [
  // Fruits
  { name: 'Pomme', emoji: '🍎', category: 'fruits' },
  { name: 'Banane', emoji: '🍌', category: 'fruits' },
  { name: 'Poire', emoji: '🍐', category: 'fruits' },
  { name: 'Pêche', emoji: '🍑', category: 'fruits' },
  { name: 'Nectarine', emoji: '🍑', category: 'fruits' },
  { name: 'Abricot', emoji: '🍑', category: 'fruits' },
  { name: 'Fraise', emoji: '🍓', category: 'fruits' },
  { name: 'Framboise', emoji: '🫐', category: 'fruits' },
  { name: 'Myrtille', emoji: '🫐', category: 'fruits' },
  { name: 'Mûre', emoji: '🫐', category: 'fruits' },
  { name: 'Cassis', emoji: '🫐', category: 'fruits' },
  { name: 'Groseille', emoji: '🫐', category: 'fruits' },
  { name: 'Raisin', emoji: '🍇', category: 'fruits' },
  { name: 'Orange', emoji: '🍊', category: 'fruits' },
  { name: 'Clémentine', emoji: '🍊', category: 'fruits' },
  { name: 'Mandarine', emoji: '🍊', category: 'fruits' },
  { name: 'Pamplemousse', emoji: '🍊', category: 'fruits' },
  { name: 'Citron', emoji: '🍋', category: 'fruits' },
  { name: 'Mangue', emoji: '🥭', category: 'fruits' },
  { name: 'Papaye', emoji: '🥭', category: 'fruits' },
  { name: 'Ananas', emoji: '🍍', category: 'fruits' },
  { name: 'Noix de coco', emoji: '🥥', category: 'fruits' },
  { name: 'Kiwi', emoji: '🥝', category: 'fruits' },
  { name: 'Melon', emoji: '🍈', category: 'fruits' },
  { name: 'Pastèque', emoji: '🍉', category: 'fruits' },
  { name: 'Cerise', emoji: '🍒', category: 'fruits' },
  { name: 'Prune', emoji: '🫐', category: 'fruits' },
  { name: 'Mirabelle', emoji: '🫐', category: 'fruits' },
  { name: 'Figue', emoji: '🫐', category: 'fruits' },
  { name: 'Litchi', emoji: '🫐', category: 'fruits' },
  { name: 'Fruit de la passion', emoji: '🫐', category: 'fruits' },
  { name: 'Grenade', emoji: '🫐', category: 'fruits' },
  { name: 'Pruneau', emoji: '🫐', category: 'fruits' },
  { name: 'Datte', emoji: '🫐', category: 'fruits' },
  { name: 'Raisin sec', emoji: '🍇', category: 'fruits' },

  // Légumes
  { name: 'Carotte', emoji: '🥕', category: 'vegetables' },
  { name: 'Courgette', emoji: '🥒', category: 'vegetables' },
  { name: 'Haricot vert', emoji: '🫛', category: 'vegetables' },
  { name: 'Petit pois', emoji: '🫛', category: 'vegetables' },
  { name: 'Épinard', emoji: '🥬', category: 'vegetables' },
  { name: 'Brocoli', emoji: '🥦', category: 'vegetables' },
  { name: 'Chou-fleur', emoji: '🥦', category: 'vegetables' },
  { name: 'Chou vert', emoji: '🥬', category: 'vegetables' },
  { name: 'Chou rouge', emoji: '🥬', category: 'vegetables' },
  { name: 'Chou de Bruxelles', emoji: '🥬', category: 'vegetables' },
  { name: 'Chou chinois', emoji: '🥬', category: 'vegetables' },
  { name: 'Patate douce', emoji: '🍠', category: 'vegetables' },
  { name: 'Potiron', emoji: '🎃', category: 'vegetables' },
  { name: 'Potimarron', emoji: '🎃', category: 'vegetables' },
  { name: 'Butternut', emoji: '🎃', category: 'vegetables' },
  { name: 'Courge spaghetti', emoji: '🎃', category: 'vegetables' },
  { name: 'Citrouille', emoji: '🎃', category: 'vegetables' },
  { name: 'Poireau', emoji: '🥬', category: 'vegetables' },
  { name: 'Aubergine', emoji: '🍆', category: 'vegetables' },
  { name: 'Tomate', emoji: '🍅', category: 'vegetables' },
  { name: 'Concombre', emoji: '🥒', category: 'vegetables' },
  { name: 'Avocat', emoji: '🥑', category: 'vegetables' },
  { name: 'Artichaut', emoji: '🥬', category: 'vegetables' },
  { name: 'Betterave', emoji: '🫒', category: 'vegetables' },
  { name: 'Fenouil', emoji: '🥬', category: 'vegetables' },
  { name: 'Céleri', emoji: '🥬', category: 'vegetables' },
  { name: 'Maïs', emoji: '🌽', category: 'vegetables' },
  { name: 'Champignon', emoji: '🍄', category: 'vegetables' },
  { name: 'Navet', emoji: '🥬', category: 'vegetables' },
  { name: 'Radis', emoji: '🥬', category: 'vegetables' },
  { name: 'Panais', emoji: '🥕', category: 'vegetables' },
  { name: 'Topinambour', emoji: '🥔', category: 'vegetables' },
  { name: 'Rutabaga', emoji: '🥕', category: 'vegetables' },
  { name: 'Asperge', emoji: '🥬', category: 'vegetables' },
  { name: 'Endive', emoji: '🥬', category: 'vegetables' },
  { name: 'Laitue', emoji: '🥬', category: 'vegetables' },
  { name: 'Mâche', emoji: '🥬', category: 'vegetables' },
  { name: 'Roquette', emoji: '🥬', category: 'vegetables' },
  { name: 'Blette', emoji: '🥬', category: 'vegetables' },
  { name: 'Poivron', emoji: '🫑', category: 'vegetables' },
  { name: 'Oignon', emoji: '🧅', category: 'vegetables' },
  { name: 'Échalote', emoji: '🧅', category: 'vegetables' },
  { name: 'Ail', emoji: '🧄', category: 'vegetables' },

  // Féculents
  { name: 'Pomme de terre', emoji: '🥔', category: 'starches' },
  { name: 'Riz', emoji: '🍚', category: 'starches' },
  { name: 'Pâtes', emoji: '🍝', category: 'starches' },
  { name: 'Semoule', emoji: '🍚', category: 'starches' },
  { name: 'Couscous', emoji: '🍚', category: 'starches' },
  { name: 'Quinoa', emoji: '🍚', category: 'starches' },
  { name: 'Boulgour', emoji: '🍚', category: 'starches' },
  { name: 'Millet', emoji: '🍚', category: 'starches' },
  { name: 'Sarrasin', emoji: '🍚', category: 'starches' },
  { name: 'Épeautre', emoji: '🍚', category: 'starches' },
  { name: 'Orge', emoji: '🍚', category: 'starches' },
  { name: 'Avoine', emoji: '🍚', category: 'starches' },
  { name: 'Pain', emoji: '🍞', category: 'starches' },
  { name: 'Biscottes', emoji: '🍞', category: 'starches' },
  { name: 'Céréales bébé', emoji: '🥣', category: 'starches' },
  { name: 'Polenta', emoji: '🍚', category: 'starches' },
  { name: 'Tapioca', emoji: '🍚', category: 'starches' },
  { name: 'Lentilles', emoji: '🫘', category: 'starches' },
  { name: 'Pois chiches', emoji: '🫘', category: 'starches' },
  { name: 'Haricots blancs', emoji: '🫘', category: 'starches' },
  { name: 'Haricots rouges', emoji: '🫘', category: 'starches' },
  { name: 'Flageolets', emoji: '🫘', category: 'starches' },
  { name: 'Pois cassés', emoji: '🫘', category: 'starches' },
  { name: 'Fèves', emoji: '🫘', category: 'starches' },

  // Protéines
  { name: 'Poulet', emoji: '🍗', category: 'proteins' },
  { name: 'Dinde', emoji: '🍗', category: 'proteins' },
  { name: 'Bœuf', emoji: '🥩', category: 'proteins' },
  { name: 'Veau', emoji: '🥩', category: 'proteins' },
  { name: 'Jambon', emoji: '🥓', category: 'proteins' },
  { name: 'Porc', emoji: '🥓', category: 'proteins' },
  { name: 'Agneau', emoji: '🍖', category: 'proteins' },
  { name: 'Lapin', emoji: '🍖', category: 'proteins' },
  { name: 'Canard', emoji: '🍗', category: 'proteins' },
  { name: 'Saumon', emoji: '🐟', category: 'proteins' },
  { name: 'Cabillaud', emoji: '🐟', category: 'proteins' },
  { name: 'Colin', emoji: '🐟', category: 'proteins' },
  { name: 'Lieu', emoji: '🐟', category: 'proteins' },
  { name: 'Merlu', emoji: '🐟', category: 'proteins' },
  { name: 'Sole', emoji: '🐟', category: 'proteins' },
  { name: 'Dorade', emoji: '🐟', category: 'proteins' },
  { name: 'Bar', emoji: '🐟', category: 'proteins' },
  { name: 'Truite', emoji: '🐟', category: 'proteins' },
  { name: 'Sardine', emoji: '🐟', category: 'proteins' },
  { name: 'Maquereau', emoji: '🐟', category: 'proteins' },
  { name: 'Thon', emoji: '🐟', category: 'proteins' },
  { name: 'Crevette', emoji: '🦐', category: 'proteins' },
  { name: 'Crabe', emoji: '🦀', category: 'proteins' },
  { name: 'Moule', emoji: '🦪', category: 'proteins' },
  { name: 'Œuf', emoji: '🥚', category: 'proteins' },
  { name: 'Tofu', emoji: '🧈', category: 'proteins' },

  // Produits laitiers
  { name: 'Yaourt', emoji: '🥛', category: 'dairy' },
  { name: 'Fromage blanc', emoji: '🥛', category: 'dairy' },
  { name: 'Petit-suisse', emoji: '🥛', category: 'dairy' },
  { name: 'Faisselle', emoji: '🥛', category: 'dairy' },
  { name: 'Fromage fondu', emoji: '🧀', category: 'dairy' },
  { name: 'Vache qui rit', emoji: '🧀', category: 'dairy' },
  { name: 'Kiri', emoji: '🧀', category: 'dairy' },
  { name: 'Babybel', emoji: '🧀', category: 'dairy' },
  { name: 'Gruyère', emoji: '🧀', category: 'dairy' },
  { name: 'Emmental', emoji: '🧀', category: 'dairy' },
  { name: 'Comté', emoji: '🧀', category: 'dairy' },
  { name: 'Parmesan', emoji: '🧀', category: 'dairy' },
  { name: 'Mozzarella', emoji: '🧀', category: 'dairy' },
  { name: 'Ricotta', emoji: '🧀', category: 'dairy' },
  { name: 'Chèvre', emoji: '🧀', category: 'dairy' },
  { name: 'Beurre', emoji: '🧈', category: 'dairy' },
  { name: 'Crème fraîche', emoji: '🥛', category: 'dairy' },

  // Autres
  { name: 'Huile d\'olive', emoji: '🫒', category: 'other' },
  { name: 'Huile de colza', emoji: '🫒', category: 'other' },
  { name: 'Persil', emoji: '🌿', category: 'other' },
  { name: 'Ciboulette', emoji: '🌿', category: 'other' },
  { name: 'Basilic', emoji: '🌿', category: 'other' },
  { name: 'Coriandre', emoji: '🌿', category: 'other' },
  { name: 'Menthe', emoji: '🌿', category: 'other' },
  { name: 'Cannelle', emoji: '🌿', category: 'other' },
  { name: 'Vanille', emoji: '🌿', category: 'other' },
  { name: 'Miel', emoji: '🍯', category: 'other' },
  { name: 'Confiture', emoji: '🍯', category: 'other' },
  { name: 'Biscuit bébé', emoji: '🍪', category: 'other' },
  { name: 'Galette de riz', emoji: '🍘', category: 'other' },
  { name: 'Amande', emoji: '🥜', category: 'other' },
  { name: 'Noisette', emoji: '🌰', category: 'other' },
  { name: 'Noix', emoji: '🌰', category: 'other' },
  { name: 'Noix de cajou', emoji: '🥜', category: 'other' },
  { name: 'Cacahuète', emoji: '🥜', category: 'other' },
  { name: 'Sésame', emoji: '🌿', category: 'other' },
];

// Réactions possibles
export const REACTIONS = [
  { value: 'liked', label: 'A aimé', emoji: '😋' },
  { value: 'neutral', label: 'Neutre', emoji: '😐' },
  { value: 'disliked', label: 'N\'a pas aimé', emoji: '😖' },
  { value: 'allergy', label: 'Réaction/Allergie', emoji: '⚠️' }
];

// Fonction de recherche d'aliments
export function searchFoods(query) {
  if (!query || query.length < 1) {
    return [];
  }

  const normalizedQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return FOODS.filter(food => {
    const normalizedName = food.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalizedName.includes(normalizedQuery);
  }).slice(0, 8); // Limiter à 8 résultats
}

// Fonction pour obtenir un aliment par son nom
export function getFoodByName(name) {
  return FOODS.find(food => food.name.toLowerCase() === name.toLowerCase());
}

// Fonction pour obtenir l'emoji d'un aliment
export function getFoodEmoji(foodName) {
  const food = getFoodByName(foodName);
  return food ? food.emoji : '🥄';
}
